// extracted by mini-css-extract-plugin
module.exports = {"root":"FeedProgramme_root__3eEln","rootIsSyncing":"FeedProgramme_rootIsSyncing__19m_Z","syncBtn":"FeedProgramme_syncBtn__2TXFM","rootIsActive":"FeedProgramme_rootIsActive__ESiqB"};